import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { companyPreferencesStateSelector } from '~/selectors';

export const useCompanyPreferences = <T extends object>(
  resolveCompanyPreferences: (
    remoteCompanyPreferences: Partial<T> | undefined,
  ) => T,
  key: string,
): { companyWorkspaces: T; hasDataCompanyWorkspaces: boolean } => {
  const rawCompanyPreferences = useSelector((state: StoreState) => {
    const selectorState =
      companyPreferencesStateSelector(state).companyPreferences[key];

    return { rawData: selectorState?.data, hasData: !selectorState?.hasData };
  });

  const data = useMemo(() => {
    return resolveCompanyPreferences(rawCompanyPreferences.rawData);
  }, [resolveCompanyPreferences, rawCompanyPreferences.rawData]);

  return {
    companyWorkspaces: data,
    hasDataCompanyWorkspaces: rawCompanyPreferences.hasData,
  };
};
